import classNames from "classnames";
import styles from "./UpdatesPage.module.scss";
import chipStyles from "../enhancedSearch/SearchResults/EnhancedSearchResults.module.scss";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDitaContent, selectDitaContent } from "../Content/ContentSlice";
import { parseCreatedDate } from "./updatesFilterUtils";

const UpdateCard = ({ update, selected, guidelineLabel }) => {
  const content = useSelector(selectDitaContent);
  const dispatch = useDispatch();

  let title = "";
  let updateText = "";
  let updateDate = "";
  const updateContent = getDitaContent(
    "Updates/" + update.attributes.href.value,
    content,
    dispatch,
  );
  if (updateContent) {
    const metaProps = updateContent.getElementsByTagName("othermeta")?.[0];
    if (metaProps?.attributes.name?.value !== "hidden") {
      const titleEl =
        updateContent.getElementsByTagName("title")?.[0] ||
        updateContent.getElementsByTagName("ditatitle")?.[0];
      title = titleEl?.textContent;
    }
    updateText = updateContent.getElementsByTagName("conbody")?.[0]?.innerHTML;
    const rawDate = updateContent.getElementsByTagName("created")?.[0]?.attributes?.date?.value;
    const parsed = parseCreatedDate(rawDate);
    if (parsed) {
      updateDate = parsed.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
    }
  }

  const fullHref = update.getAttribute("href");
  const filename = fullHref.split("/").pop();
  const [expanded, setExpanded] = useState(selected === filename);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  // Check if text is actually truncated
  useEffect(() => {
    if (textRef.current && updateText && !expanded) {
      const element = textRef.current;

      const checkTruncation = () => {
        if (element) {
          const isOverflowing = element.scrollHeight > element.clientHeight;
          setIsTruncated(isOverflowing);
        }
      };

      checkTruncation();

      // Also check after a short delay to ensure CSS is fully applied
      const timer = setTimeout(checkTruncation, 100);

      // Create ResizeObserver to watch for size changes (zoom, window resize, etc.)
      const resizeObserver = new ResizeObserver(() => {
        checkTruncation();
      });

      resizeObserver.observe(element);

      return () => {
        clearTimeout(timer);
        resizeObserver.disconnect();
      };
    }
  }, [updateText, expanded]);
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <div className={styles.updateSection}>
      <div className={styles.updateCard}>
        <div className={classNames("size-14 light", styles.cardMeta)}>
          <span>{updateDate}</span>
        </div>
        <div className="size-18 medium">{title}</div>
        <div
          className={expanded ? "" : styles.updateText}
          ref={textRef}
          dangerouslySetInnerHTML={{ __html: updateText }}
        ></div>
        {guidelineLabel ? (
          <div className={classNames(chipStyles.guidelineChip, styles.guidelineChipOverride)}>
            <div
              className={classNames(
                chipStyles[guidelineLabel.replace(/ /g, "").toLowerCase()],
                chipStyles.guidelineIcon,
              )}
            ></div>
            <div className={classNames("size-12", chipStyles.guidelineText)}>{guidelineLabel}</div>
          </div>
        ) : null}
        {isTruncated && (
          <div
            className={classNames("size-14 medium", styles.readMoreLink)}
            onClick={toggleExpanded}
          >
            <div>{expanded ? "Show less" : "Read more"}</div>
            <i
              className={classNames(
                expanded ? "tg-icons-ChevronUp" : "tg-icons-ChevronDown",
                styles.readMoreIcon,
              )}
            ></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateCard;
